import { makeRequest } from './services';
import { jwtToken } from './context';
import { resolveAuth, rejectAuth } from './authReady';

export async function oneTimeAuth({ oneTimeToken, source, sourceUrl, sourceType, taker }) {
  const { data, errorMessage } = await makeRequest('post', 'appointment/page/auth/one-time', {
    oneTimeToken,
    source,
    sourceUrl,
    sourceType,
    taker
  });
  if (errorMessage) {
    rejectAuth(new Error(errorMessage));
    return { errorMessage };
  }
  if (data.newOneTimeToken) {
    oneTimeToken = data.newOneTimeToken;
  }
  jwtToken.token = data.token;
  jwtToken.slots = data.slots;
  jwtToken.timeZone = data.timeZone;
  jwtToken.apptInfo = data.apptInfo;
  jwtToken.userInfo = data.userInfo;
  jwtToken.parentUrl = data.parentUrl;
  jwtToken.trustedForm = data.trustedForm;
  jwtToken.noPoBox = data.noPoBox;
  jwtToken.needsHomeYear = data.userInfo?.needsHomeYear;
  jwtToken.needsPhone = data.userInfo?.needsPhone;
  jwtToken.needsAddress = data.userInfo?.needsAddress;
  jwtToken.zipCode = data.userInfo?.zipCode;
  jwtToken.data = { ...data, oneTimeToken };
  resolveAuth();
  window.dispatchEvent(new CustomEvent('hvs:auth-ready'));
  return { styleData: data?.styleData };
}
